import PageTemplate from '../containers/common/PageTemplate';

import Container from '../containers/category';

export default function Brand() {
  return (
    <>
      <PageTemplate>
        <Container />
      </PageTemplate>
    </>
  );
}
